import React, { useMemo, useCallback } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import PreloaderComponent from '#component/preloader';
import NotFoundMessage from '#component/general/not-found-message';
import { changeOrderAndOrderBy } from '#action/user/users-paginated';
import tableNameType from '#type/table-name-type';
import ConfigurableTable from '#component/table/configurable-table/configurable-table';
import propTypes from './prop-types';

const TableView = props => {
  const dispatch = useDispatch();
  const { users, replaceHistoryParams } = props;
  const {
    status,
    order,
    orderBy
  } = useSelector(s => s.usersPaginated, shallowEqual);
  const loading = ['loading', 'idle'].includes(status);

  const handleRequestSort = useCallback((event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    const newOrder = isAsc ? 'desc' : 'asc';
    replaceHistoryParams({ filterType: 'order', value: newOrder });
    dispatch(changeOrderAndOrderBy(newOrder, property));
  }, [dispatch, order, orderBy, replaceHistoryParams]);

  const tableHeadProps = useMemo(() => ({
    order,
    orderBy,
    handleRequestSort
  }), [order, orderBy, handleRequestSort]);

  const tableBodyProps = useMemo(() => ({
    loading
  }), [loading]);

  if (!users.length && loading) {
    return <PreloaderComponent />;
  }

  if (!users.length && !loading) {
    return (
      <NotFoundMessage style={{ marginTop: -50 }}>
        No users
      </NotFoundMessage>
    );
  }

  return (
    <ConfigurableTable
      data={users}
      headCellProps={tableHeadProps}
      bodyCellProps={tableBodyProps}
      tableName={tableNameType.USER_TABLE}
    />
  );
};

TableView.propTypes = propTypes;

export default TableView;
